<template>
  <div :class="`flex flex-col gap-y-2 ${props.styleProp ? props.styleProp : ''}`">
    <label :for="props.id" class="label-lg">
      {{ props.label }}
    </label>
    <input
      :id="props.id"
      :type="props.type"
      :placeholder="props.placeholder"
      :name="props.name"
      :required="props.required"
      :pattern="props.pattern"
      :class="`input-field ${!isValid ? 'input-error-field' : ''}`"
      :aria-invalid="!isValid ? 'true' : 'false'"
      :aria-describedby="!isValid ? `${props.id}-error` : undefined"
      @input="onInput"
    />
    <span
      v-if="!isValid"
      :id="`${props.id}-error`"
      class="min-h-[1.4rem] body-sm"
      aria-live="polite"
      >{{ errorText }}</span
    >
    <div v-else class="min-h-[1.4rem]"></div>
  </div>
</template>
<script setup lang="ts">
import { InputFieldId } from '../modules/types'

const props = defineProps<{
  label?: string
  type: string
  id: InputFieldId
  name: string
  required: boolean
  placeholder?: string
  styleProp?: string
  errorText: string
  pattern?: string
  isValid: boolean
}>()

const emit = defineEmits<{
  (e: 'input', id: InputFieldId, input: HTMLInputElement): void
}>()

const onInput = (e: Event) => {
  const input = e.target as HTMLInputElement
  emit('input', props.id, input)
}
</script>
<style></style>
